import type { PropsWithChildren } from "react";

import { AppContent } from "@/components/app-content";
import { AppSidebar } from "@/components/app-sidebar";
import { AppShell } from "@/components/app-shell";
import { AppSidebarHeader } from "@/components/app-sidebar-header";
import { WorkspaceNavigation } from "@/components/workspace-navigation";

import { BreadcrumbItem } from "@/types";

export default function AppLayout({
  children,
  breadcrumbs,
  showWorkspaceNavigation = true,
}: PropsWithChildren<React.ComponentProps<typeof AppContent>> & {
  breadcrumbs: BreadcrumbItem[];
  showWorkspaceNavigation?: boolean;
}) {
  return (
    <AppShell>
      <AppSidebar />
      <AppContent>
        <AppSidebarHeader breadcrumbs={breadcrumbs} />
        {showWorkspaceNavigation && <WorkspaceNavigation />}
        {children}
      </AppContent>
    </AppShell>
  );
}
